export const getSecondsFromString = (str) => {
    var ret = 0;
    var seconds = str.match(/(\d+)\s*s/);
    var days = str.match(/(\d+)\s*d/);
    var hours = str.match(/(\d+)\s*h/);
    var minutes = str.match(/(\d+)\s*m/);
    if (days) {
        ret += parseInt(days[1], 10) * 86400;
    }
    if (hours) {
        ret += parseInt(hours[1], 10) * 3600;
    }
    if (minutes) {
        ret += parseInt(minutes[1], 10) * 60;
    }
    if (seconds) {
        ret += parseInt(seconds[1], 10);
    }
    return ret;
};
/**
 * Format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
 * Generates a GUID (Globally Unique Identifier) with a combination of random hexadecimal digits.
*/
export const guid = () => {
    const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};
/**
 * Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 * Generates a UUID (Universally Unique Identifier) following the RFC4122 standard.
 */
export const uuid = () => {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    const uuid = [];
    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (let i = 0; i < 36; i++) {
        if (!uuid[i]) {
            const r = 0 | Math.random() * 16;
            uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
        }
    }
    return uuid.join('');
};
export const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
//# sourceMappingURL=helper.js.map